import { ACTION, HIDDEN_ENHANCED_PROVIDERS_BY_ACTION, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

/**
 * Resolves the providers hidden from the AI Engine selector for an enhanced
 * action. Extends the static HIDDEN_ENHANCED_PROVIDERS_BY_ACTION map with
 * per-user Flipper flags from pageConfig: until enable_hunyuan_segmentation is
 * on, Hunyuan (tencent) is hidden from the segmentation flow, and until
 * enable_meshy_remesh is on, Meshy is hidden from the remesh flow. Callers feed
 * the result into both the selector and availableEnhancedProviders so a hidden
 * provider can never become the auto-selected active provider.
 *
 * @param {string|null} enhancedAction - From schema.enhancedAction.
 * @param {Object} featureFlags - Flag values from pageConfig.
 * @param {boolean} featureFlags.enableHunyuanSegmentation
 * @param {boolean} featureFlags.enableMeshyRemesh
 * @returns {string[]} - Provider ids to hide for the action.
 */
export const getHiddenEnhancedProviders = (enhancedAction, featureFlags = EMPTY_OBJECT) => {
  const actionHiddenProviders = HIDDEN_ENHANCED_PROVIDERS_BY_ACTION[enhancedAction] || EMPTY_ARRAY
  const hiddenProviders = new Set(actionHiddenProviders)

  if (enhancedAction === ACTION.MESH_SEGMENTATION && !featureFlags.enableHunyuanSegmentation) {
    hiddenProviders.add(PROVIDER.TENCENT)
  }

  if (enhancedAction === ACTION.MESH_SIMPLIFICATION && !featureFlags.enableMeshyRemesh) {
    hiddenProviders.add(PROVIDER.MESHY)
  }

  return [...hiddenProviders]
}
